import type { ComponentType } from 'react'

const pages = import.meta.glob<{ default: ComponentType }>(['../pages/**/*.tsx', '!../pages/**/*.test.tsx'])

export async function resolvePage(name: string) {
  const load = pages[`../pages/${name}.tsx`]
  if (!load) throw new Error(`Page not found: ${name}`)
  return (await load()).default
}
